export const FacebookIcon: React.FC<{ className?: string }> = ({
	className,
}) => {
	return (
		<svg
			className={className}
			fill="none"
			height="20"
			viewBox="0 0 20 20"
			width="20"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.6687 2.5H3.33125C3.11129 2.50164 2.90081 2.58974 2.74527 2.74527C2.58974 2.90081 2.50164 3.11129 2.5 3.33125V16.6687C2.50164 16.8887 2.58974 17.0992 2.74527 17.2547C2.90081 17.4103 3.11129 17.4984 3.33125 17.5H10.5125V11.7H8.5625V9.43125H10.5125V7.7625C10.5125 5.825 11.6937 4.76875 13.4312 4.76875C14.0125 4.76875 14.5938 4.76875 15.175 4.85625V6.875H13.9813C13.0375 6.875 12.8562 7.325 12.8562 7.98125V9.425H15.1062L14.8125 11.6937H12.8562V17.5H16.6687C16.8887 17.4984 17.0992 17.4103 17.2547 17.2547C17.4103 17.0992 17.4984 16.8887 17.5 16.6687V3.33125C17.4984 3.11129 17.4103 2.90081 17.2547 2.74527C17.0992 2.58974 16.8887 2.50164 16.6687 2.5Z"
				fill="#1877F2"
			/>
		</svg>
	);
};
